import {addPrevNextBtnsClickHandlers} from './EmblaCarouselArrowButtons.js';
import {setupTweenScale} from './EmblaCarouselTweenScale.js';

// the align option set the left position of the slides, by the fault is center
const OPTIONS = {loop: true, align: 'start'};

const emblaNode = document.querySelector('.embla')
const controlsNode = document.querySelector('.lab-life--buttons')
if (emblaNode && controlsNode) {
    const viewportNode = emblaNode.querySelector('.embla__viewport')
    const prevBtnNode = controlsNode.querySelector('.button--prev')
    const nextBtnNode = controlsNode.querySelector('.button--next')

    if (viewportNode && prevBtnNode && nextBtnNode) {
        const emblaApi = EmblaCarousel(viewportNode, OPTIONS, []);
        const removeTweenScale = setupTweenScale(emblaApi);

        const onNavButtonClick = (emblaApi) => {
        }

        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
            emblaApi,
            prevBtnNode,
            nextBtnNode,
            onNavButtonClick
        );

        emblaApi
            .on('destroy', removePrevNextBtnsClickHandlers)
            .on('destroy', removeTweenScale);
    }

}
